import { ForbearanceCancellationReason as GqlForbearanceCancellationReason } from '@willow/graphql-iso/src/app';
import { assertNever, ForbearanceCancellationReason } from '@willow/types-iso';

export const getForbearanceCancellationReasonLabel = (
  reason: ForbearanceCancellationReason | GqlForbearanceCancellationReason,
): string => {
  switch (reason) {
    case 'insufficientPayments':
    case GqlForbearanceCancellationReason.InsufficientPayments:
      return 'One or more insufficient payments were made';
    case 'noLongerEligible':
    case GqlForbearanceCancellationReason.NoLongerEligible:
      return 'No longer eligible for forbearance';
    case 'evaluatingDifferentPlan':
    case GqlForbearanceCancellationReason.EvaluatingDifferentPlan:
      return 'Evaluating for a different plan';
    case 'loanReinstated':
    case GqlForbearanceCancellationReason.LoanReinstated:
      return 'Loan has been reinstated';
    case 'repaymentPlanSelected':
    case GqlForbearanceCancellationReason.RepaymentPlanSelected:
      return 'A repayment plan has been selected';
    case 'defermentSelected':
    case GqlForbearanceCancellationReason.DefermentSelected:
      return 'A deferment has been selected';
    case 'flexModificationSelected':
    case GqlForbearanceCancellationReason.FlexModificationSelected:
      return 'A flex modification has been selected';
    default:
      assertNever(reason);
  }
};
